/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Rule_RankInputs */

const en_directory_vibebids_rule_rank = /** @type {(inputs: Directory_Vibebids_Rule_RankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rank equals the total bid, not an editorial score.`)
};

const zh_directory_vibebids_rule_rank = /** @type {(inputs: Directory_Vibebids_Rule_RankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排名等于总出价，不是编辑评分。`)
};

/**
* | output |
* | --- |
* | "Rank equals the total bid, not an editorial score." |
*
* @param {Directory_Vibebids_Rule_RankInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_rule_rank = /** @type {((inputs?: Directory_Vibebids_Rule_RankInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Rule_RankInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_rule_rank(inputs)
	return zh_directory_vibebids_rule_rank(inputs)
});
export { directory_vibebids_rule_rank as "directory.vibebids.rule_rank" }